// storefront/assets/weebot-collection-compare.js
// Injecte les pills "Comparer" sur les cartes de collection, gère la barre sticky + la
// sélection persistante, ouvre la pop-up. Réutilise window.WBCompare (moteur + selection).
(function () {
  // document.currentScript is null for deferred scripts; fall back to querying by src.
  const _cs = document.currentScript;
  function getRoot() {
    if (_cs) return _cs.dataset.index || null;
    const el = document.querySelector('script[src*="weebot-collection-compare"]');
    return el ? (el.dataset.index || null) : null;
  }
  const MAX = (typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(max-width:780px)').matches) ? 3 : 4;
  const CHECK = '<svg viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.2 4.3L19 7"/></svg>';
  const CMP = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h7M3 12h7M3 18h7M17 4v16M14 7l3-3 3 3M14 17l3 3 3-3"/></svg>';
  const sz = (u, w) => (!u || /[?&]width=/.test(u)) ? u : (u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w);

  function handleFromCard(card) {
    const a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    const m = /\/products\/([a-z0-9-]+)/.exec(a.getAttribute('href') || '');
    return m ? m[1] : null;
  }

  function run(indexSet, sel) {
    // Bar is lazy: created and inserted only on first selection, so DOM count = 0 initially.
    let bar = null;
    function inject(card) {
      if (card.querySelector('.wb-cmp-pill')) return false;
      const h = handleFromCard(card);
      if (!h || !indexSet.has(h)) return false;            // specs only
      const pill = document.createElement('div');
      pill.className = 'wb-cmp-pill';
      pill.dataset.h = h;
      pill.innerHTML = `<span class="wb-cmp-pill-box"></span> Comparer`;
      pill.addEventListener('click', () => {
        if (!sel.has(h) && sel.isFull()) return;
        sel.toggle(h);
        if (!bar) bar = ensureBar(sel, indexSet);
        refresh(sel, indexSet, bar);
      });
      card.appendChild(pill);
      return true;
    }
    document.querySelectorAll('.product-item').forEach(inject);
    // Restore persisted selection: if sessionStorage has items, show bar immediately.
    if (sel.list().length > 0) {
      bar = ensureBar(sel, indexSet);
      refresh(sel, indexSet, bar);
    }
    const grid = document.querySelector('.product-list, .collection, main') || document.body;
    new MutationObserver(muts => {
      let injected = false;
      for (const m of muts) for (const n of m.addedNodes) {
        if (n.nodeType !== 1) continue;
        if (n.matches && n.matches('.product-item')) { if (inject(n)) injected = true; }
        n.querySelectorAll && n.querySelectorAll('.product-item').forEach(c => { if (inject(c)) injected = true; });
      }
      // Only refresh if new pills were injected; avoids infinite loop from subtree mutations.
      if (injected) {
        if (!bar) bar = ensureBar(sel, indexSet);
        refresh(sel, indexSet, bar);
      }
    }).observe(grid, { childList: true, subtree: true });
  }

  function ensureBar(sel, indexSet) {
    let bar = document.querySelector('.wb-cmp-bar');
    if (bar) return bar;
    bar = document.createElement('div');
    bar.className = 'wb-cmp-bar';
    bar.innerHTML = `<div class="wb-cmp-bar-in">
      <div class="wb-cmp-bar-lab"></div>
      <div class="wb-cmp-bar-thumbs"></div>
      <button class="wb-cmp-bar-x" type="button" aria-label="Tout effacer">✕</button>
      <button class="wb-cmp-bar-go">Comparer</button>
      <span class="wb-cmp-bar-clear">Tout effacer</span>
    </div>`;
    document.body.appendChild(bar);
    bar.querySelector('.wb-cmp-bar-clear').onclick = () => { sel.clear(); refresh(sel, indexSet, bar); };
    bar.querySelector('.wb-cmp-bar-x').onclick = () => { sel.clear(); refresh(sel, indexSet, bar); };
    bar.querySelector('.wb-cmp-bar-go').onclick = () => {
      const list = sel.list();
      if (list.length && window.WBCompare) window.WBCompare.openComparisonPopup(list, { index: window.__WB_INDEX });
    };
    return bar;
  }

  function refresh(sel, indexSet, bar) {
    const list = sel.list(), full = list.length >= MAX;
    document.querySelectorAll('.wb-cmp-pill').forEach(p => {
      const on = sel.has(p.dataset.h);
      p.classList.toggle('wb-cmp-pill-on', on);
      p.querySelector('.wb-cmp-pill-box').innerHTML = on ? CHECK : '';
      p.classList.toggle('wb-cmp-pill-disabled', !on && full);
    });
    bar.style.display = list.length ? 'block' : 'none';
    bar.querySelector('.wb-cmp-bar-lab').innerHTML = `<b>${list.length}</b><br>à comparer`;
    bar.querySelector('.wb-cmp-bar-go').innerHTML = `${CMP}<span class="wb-cmp-go-full">Comparer </span>(${list.length})`;
    const idx = window.__WB_INDEX_MAP || {};
    const thumbs = bar.querySelector('.wb-cmp-bar-thumbs');
    const tcache = window.__WB_THUMB || (window.__WB_THUMB = {});
    thumbs.innerHTML = list.map(h =>
      `<div class="wb-cmp-thumb"><img src="${tcache[h] || ''}" alt="" data-h="${h}"><span class="wb-cmp-thumb-x" data-h="${h}">✕</span></div>`
    ).join('');
    // toujours l'image LIVE du produit (l'index a des URLs périmées ou d'anciennes images) — cachée
    list.forEach(h => {
      if (tcache[h]) return;
      fetch(`/products/${h}.js`).then(r => r.json()).then(p => {
        let u = p.featured_image || (p.images && p.images[0]);
        if (!u) return;
        if (u.indexOf('//') === 0) u = 'https:' + u;
        tcache[h] = sz(u, 160);
        const img = thumbs.querySelector(`img[data-h="${h}"]`);
        if (img) img.src = tcache[h];
      }).catch(() => {});
    });
    bar.querySelectorAll('.wb-cmp-thumb-x').forEach(x => x.onclick = () => { sel.remove(x.dataset.h); refresh(sel, indexSet, bar); });
  }

  async function boot() {
    const ROOT = getRoot();
    if (!ROOT) return;
    // ES modules (weebot-compare-engine.js + weebot-selection.js) may not have
    // finished executing yet even though they are deferred before this script.
    // Yield one microtask tick so their module bodies complete first.
    if (!window.WBCompare) {
      await Promise.resolve();
      if (!window.WBCompare) return;
    }
    let data;
    try { data = await (await fetch(ROOT)).json(); } catch { return; }
    const products = Array.isArray(data) ? data : (data.products || []);
    window.__WB_INDEX = data;
    window.__WB_INDEX_MAP = Object.fromEntries(products.map(p => [p.handle, p]));
    const indexSet = new Set(products.map(p => p.handle));
    const sel = window.WBCompare.createSelection(sessionStorage, MAX, 'wb_cmp_sel');
    run(indexSet, sel);
  }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
